import styled from 'styled-components';
import { Theme } from '@routific/hive';
import { Skeleton } from 'antd';

export const InlineDiv = styled.div<{ isHovered?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  width:100%;
  gap: ${Theme.Spacing.xsSpacing};
`;

export const LeftContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${Theme.Spacing.smSpacing};
  overflow: hidden;
  flex-grow: 1;
  flex-shrink: 1;
`;

export const RightContainer = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  .lateness { order: 2; }
`;

export const StyledSkeleton = styled(Skeleton)`
  .ant-skeleton-content { height: 16px; vertical-align: middle; }
  .ant-skeleton-title { height: 12px; margin: 0; }
`;
